export enum AvailablePropertyTypes {
    BOOLEAN = "Boolean",
    SELECT = "Select",
    TEXT = "Text",
    TEXTAREA = "TextArea",
    INTEGER = "Integer",
    JSON = "JSON",
    STRING = "String"
}